import { createContext, useContext } from 'react';

const PaperContext = createContext({});

const usePaperContext = () => {
  const context = useContext(PaperContext);

  if (!context) {
    // eslint-disable-next-line no-console
    console.warn('PaperContext cannot be used outside Provider');
  }

  return context;
};

export { PaperContext };
export default usePaperContext;
